module.exports = __webpack_public_path__ + "static/media/logo-angular.c42a69d0.svg";